import axios from 'axios'
import { getToken, getTokenTime, setToken } from '@/ulits/auth'
import moment from 'moment'
import { useCounterStore } from '@/store'
import router from '@/router'
import { showFailToast } from 'vant';
import cross from '@/assets/cross.png'  
export let baseURL // 文件下载地址
if (process.env.NODE_ENV === "production") {
  baseURL = "https://fairy.aibene.cn/";
  axios.defaults.baseURL = baseURL;
} else {
  baseURL = "https://fairy-test.aibene.cn/";
  axios.defaults.baseURL = baseURL;
}
axios.defaults.timeout = 100000;
export function upload(url, file) {
  return new Promise((resolve, reject) => {
    const params = new FormData();
    params.append('image', file);
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data;'
      } 
    }
    axios.post(url, params, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        Message({
          message: err,
          type: 'error',
          duration: 5 * 800
        })
        reject(err);
      })
  })
}

axios.interceptors.request.use(
  config => {
    if (useCounterStore().token || getToken()) {
      config.headers['token'] = getToken()
      // config.headers['sign'] = 'hg3hWXdB2UTFxPUCicYLJFMHMldFSm0j2ynDoT+KB/k='
      // 离token过期时间快到 自动延长到关闭页面为止
      const time = (Number(getTokenTime()) - moment().format('X')) < 1800
      if (time) {
        setToken(getToken())
      }
    }
    // config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    return Promise.reject(error)
  }
)


axios.interceptors.response.use(
  response=>{
    const res = response.data
    if (res.code !== 200) {
      showFailToast({
        message:res.message,
        icon:cross
      })
      return Promise.reject((res.message || '登录过期，请重新登录'))
    } else {
      return res
    }
  },error =>{
    if (error.response.data.code === 410) {
      showFailToast({
        message:error.response.data.message,
        icon:cross
      })
      localStorage.setItem('path',window.location.pathname)
      router.push({
        name:'login',
      })
      return false
    }
    if (error.response.data.code !== 200) {
      showFailToast({
        message:error.response.data.message,
        icon:cross
      })
      if (error.response.config.url === 'api/update-nick-name') {
        return error.response.data
      }
      if (error.response.config.url === 'api/app/getAnswerByAiDialogue') {
        return error.response.data
      }
    }
  }
)